import React from 'react';
import { getProductionLineRowColorLegend } from '../../utils/productionLineRowStyles';
import type { ProductionLineStage } from '../../utils/types';

interface ProductionLineRowColorGuideProps {
  activeTab: ProductionLineStage;
}

export const ProductionLineRowColorGuide: React.FC<ProductionLineRowColorGuideProps> = ({
  activeTab,
}) => {
  const items = getProductionLineRowColorLegend(activeTab);

  return (
    <div className="mb-4 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2">
      <p className="text-xs font-medium text-gray-500 mb-2">Row colors</p>
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        {items.map((item) => (
          <div key={`${item.swatchClass}-${item.label}`} className="flex items-center gap-1.5">
            <span
              className={`w-4 h-4 rounded border border-gray-200 shrink-0 ${item.swatchClass}`}
              aria-hidden
            />
            <span className="text-xs text-gray-600">
              {item.colorName}: {item.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
